import axios from 'axios';
import { GET_ERRORS, GET_USERS_LIST, SET_USER } from './types';
const api_url = process.env.REACT_APP_API_URL;

// export const addOrganization = (organization, history) => dispatch => {
//     axios.post('/api/organizations/add', organization)
//             .catch(err => {
//                 dispatch({
//                     type: GET_ERRORS,
//                     payload: err.response.data
//                 });
//             });
// }

export const addUser = (user) => dispatch => {
    axios.post(api_url+'users/register', user)
            .then(response => {
              console.log(response);
            })
            .catch(err => {
                dispatch({
                    type: GET_ERRORS,
                    payload: err.response.data
                });
            });
}

export const listUsers = (user, currentorg) => dispatch => {
  console.log('List refreshing', user, currentorg);
  axios.get(api_url+'users/list',
    { params: { organization: currentorg } }
  )
  .then(response => {
      // console.log('response.data');
      // console.log(response.data);
      // console.log('response.data');
      let d = response.data;
      let s
      switch (user) {
        case 'email':
          s = d.sort((a, b) => a.email.localeCompare(b.email));
          break;
        default:
          s = d.sort((a, b) => a.name.localeCompare(b.name));

      }

      dispatch({
          type: GET_USERS_LIST,
          payload: s
      });
  });
}
//
//
//
// export const setCurrentOrganization = organization => {
//     return {
//         type: SET_CURRENT_ORGANIZATION,
//         payload: organization
//     }
// }
